import React from 'react';

const LockOpen: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="21"
    fill="none"
    viewBox="0 0 21 21"
    width="21"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path clipRule="evenodd" d={`M11.6499 3.34961C12.0873 3.7871 12.3334 4.38038 12.3335 4.99902C12.3335
      5.55131 12.7812 5.99902 13.3335 5.99902C13.8856 5.99885 14.3335 5.5512 14.3335 4.99902C14.3334
      3.84995 13.8764 2.74811 13.064 1.93555C12.2513 1.12289 11.1488 0.666016 9.99951 0.666016C8.85036
      0.666102 7.74862 1.12297 6.93604 1.93555C6.12345 2.74813 5.66659 3.84987 5.6665 4.99902V8.17125C5.02018
      8.2118 4.40835 8.48667 3.94775 8.94727C3.44766 9.44736 3.1665 10.1258 3.1665 10.833V15.833C3.16659
      16.5401 3.44773 17.2187 3.94775 17.7188C4.44782 18.2186 5.12641 18.499 5.8335 18.499H14.1665C14.8737
      18.499 15.5522 18.2187 16.0522 17.7188C16.5523 17.2187 16.8334 16.5401 16.8335 15.833V10.833C16.8335
      10.1258 16.5522 9.44735 16.0522 8.94727C15.5521 8.44717 14.8737 8.16602 14.1665
      8.16602H7.6665V4.99902C7.66659 4.3803 7.91259 3.78712 8.3501 3.34961C8.78761 2.9121 9.38079 2.6661
      9.99951 2.66602C10.6184 2.66602 11.2123 2.91202 11.6499 3.34961ZM6.6665 10.166H5.8335C5.65669 10.166
      5.48684 10.2363 5.36182 10.3613C5.23679 10.4864 5.1665 10.6562 5.1665 10.833V15.833C5.16659 16.0096
      5.23697 16.1788 5.36182 16.3037C5.48684 16.4287 5.65669 16.499 5.8335 16.499H14.1665C14.3433 16.499
      14.5132 16.4287 14.6382 16.3037C14.7629 16.1788 14.8334 16.0095 14.8335 15.833V10.833C14.8335 10.6563
      14.7631 10.4863 14.6382 10.3613C14.5132 10.2363 14.3433 10.166 14.1665 10.166H6.6665ZM9.88232
      13.4505C9.91349 13.4816 9.9555 13.4993 9.99951 13.4993C10.0217 13.4993 10.0439 13.495 10.064
      13.4867L10.1177 13.4505C10.1332 13.435 10.1455 13.4167 10.1538 13.3968L10.1665 13.3324L10.1538
      13.2689L10.1177 13.2152C10.1022 13.1996 10.0838 13.1873 10.064 13.179L9.99951 13.1663C9.97747 13.1664
      9.95601 13.1707 9.93604 13.179L9.88232 13.2152C9.85115 13.2463 9.83358 13.2883 9.8335 13.3324L9.84619
      13.3968C9.85449 13.4167 9.8668 13.435 9.88232 13.4505ZM11.8335 13.3324C11.8335 13.8186 11.6402 14.2854
      11.2964 14.6292C10.9526 14.973 10.4857 15.1663 9.99951 15.1663C9.51348 15.1663 9.04734 14.9729 8.70361
      14.6292C8.4028 14.3284 8.21698 13.9337 8.17529 13.514L8.1665 13.3324L8.17529 13.1517C8.21692 12.7319
      8.40272 12.3374 8.70361 12.0365L8.83838 11.9144C9.16448 11.6473 9.57432 11.4994 9.99951 11.4993L10.1812
      11.5081C10.5408 11.5439 10.882 11.6854 11.1616 11.9144L11.2964 12.0365L11.4185 12.1712C11.6854 12.4973
      11.8334 12.9072 11.8335 13.3324Z`} fill="#98A2B3" fillRule="evenodd" />
  </svg>
);

export default LockOpen;
